module.exports = __webpack_public_path__ + "img/Edda_Haavamaal.dbf66373.jpg";